<template>
	<div class="phquery">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div class="position-bar-container">
			<position-bar :positionNav="positionNav">
			</position-bar>
		</div>
		<div class="phquerycont " id="1">
      <div class="phquerycont-banner">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250721/b1768185b2a4ec4bd94b638437e64cd3.jpg" alt="">
      </div>
			<div class="phquerycont-txt">
        <div class="phquerycont-hea">{{anticoniden}}</div>
        <div class="phquerycont-title">{{toptitle}}</div>
        <!--			<div class="phquerycont-inputcont">-->
        <!--				<div class="phquerycont-input">-->
        <!--					<input :placeholder="tips" v-model="quersu"/>-->
        <!--					<div class="phquery-inputbut bg" @click="oponzmnqu()" :class="$store.state.brand">{{querysub}}</div>-->
        <!--				</div>-->
        <!--			</div>-->
        <div class="phquerycont-ftitle">{{foptitle}}</div>
      </div>
		</div>
<!--		<div class="phmaintain" id="2">-->
<!--			<div class="phmaintainhea" >-->
<!--				{{maintenance}}-->
<!--			</div>-->

<!--			&lt;!&ndash; <div class="maintenance-cen">-->
<!--				<div class="parcen-item" :style="maintenancetyps==item.id?'color:'+nav_color:''" v-for="(item,index) in categorylist" @click="maintenancetypsclick(item.id)" :key="index">-->
<!--					{{item.name}}-->
<!--				</div>-->
<!--				<div class="hoverxia_icon" @click="maintenance_cen_icon_click()" :style="maintenance_cen_bool?'transform:scale(1,-1)':'transform:scale(1,1)'"></div>-->
<!--			</div>-->
<!--			<div class="pcmaintenance-cont">-->
<!--				<div class="pcmaintenance-item" v-for="(item,index) in downloadlistst_tpm" :key="index" @click="downvideo(item.file)">-->
<!--					<div class="shop-video">-->
<!--						<video :src="item.file" :id="'video'+item.id"  @mouseleave="video_out(item)" muted v-if="playing_video_id == item.id"></video>-->
<!--						<img :src="item.image" v-else class="video_title_image" @mouseenter="video_in(item)">-->
<!--					</div>-->
<!--					<div class="shop-icon"  @click="">-->
<!--						<div class="shopicon-left">-->
<!--							{{item.title}}-->
<!--						</div>-->
<!--						<div class="shopicon-right">-->
<!--							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/download.svg" />-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div> &ndash;&gt;-->

<!--			<div class="phquerydown-nav">-->
<!--				<div class="nav-cont">-->
<!--					&lt;!&ndash; <div class="navfiest" :class="downloadtyps==item.id?'downloadtypsclass':''">-->
<!--						全部-->
<!--					</div> &ndash;&gt;-->
<!--					<div class="img-list">-->
<!--						&lt;!&ndash; <el-scrollbar> &ndash;&gt;-->
<!--							<ul>-->
<!--								<li  :style="maintenancetyps==item.id?'color:'+$store.state.themeColor:''"-->
<!--								v-for="(item,index) in categorylist" @click="pcdownloadtpmlist(item.id)" :key="index"-->
<!--								>-->
<!--									{{item.name}}-->
<!--								</li>-->
<!--							</ul>-->
<!--						&lt;!&ndash; </el-scrollbar> &ndash;&gt;-->
<!--					</div>-->
<!--					&lt;!&ndash; <div class="nav-item"  :class="downloadtyps==item.id?'downloadtypsclass':''" v-for="(item,index) in downloadtypst" @click="downloadtypsclick(item.id)" :key="index">-->
<!--						{{item.name}}-->

<!--					</div> &ndash;&gt;-->
<!--				</div>-->
<!--				&lt;!&ndash; <div class="nav-but">-->
<!--					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phquerytopxia.png" />-->
<!--				</div> &ndash;&gt;-->
<!--			</div>-->


<!--			<div class="maintenance_video">-->
<!--				<div class="pcmaintenance-item" v-for="(item,index) in downloadlistst_tpm" :key="index" @click="downvideo(item.file)">-->
<!--					<div class="shop-video">-->
<!--						<video :src="item.file" :id="'video'+item.id"  @mouseleave="video_out(item)" :poster="item.image"></video>-->
<!--					</div>-->
<!--					<div class="shop-icon"  @click="">-->
<!--						<div class="shopicon-left">-->
<!--							{{item.title}}-->
<!--						</div>-->
<!--						&lt;!&ndash; <div class="shopicon-right">-->
<!--							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/download.svg" />-->
<!--						</div> &ndash;&gt;-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->


<!--			&lt;!&ndash; <div class="phmaintain-cont">-->
<!--				<div class="pamaintain-item" v-for="(item,index) in downloadlistst_tpm" :key="index">-->
<!--					<div class="maintainite-hea">-->
<!--						<img :src="item.image" />-->
<!--					</div>-->
<!--					<div class="maintainte-foo">-->
<!--						<div class="mainite-left">-->
<!--							{{item.title}}-->
<!--						</div>-->
<!--						<div @click="navtoshiyan(item.file)">{{onlinepreview}}</div>-->
<!--						<div @click="dolofle(item)">-->
<!--							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phqueryxiazai.png" />-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div> &ndash;&gt;-->
<!--		</div>-->
<!--		<div class="phquerydown" id="3">-->
<!--			<div class="phquerydown-hea">{{dadownlo}}</div>-->
<!--			<div class="phquerydown-nav">-->
<!--				<div class="nav-cont">-->
<!--					&lt;!&ndash; <div class="navfiest" :class="downloadtyps==item.id?'downloadtypsclass':''">-->
<!--						全部-->
<!--					</div> &ndash;&gt;-->
<!--					<div class="img-list">-->
<!--					   &lt;!&ndash; <el-scrollbar> &ndash;&gt;-->
<!--					        <ul>-->
<!--					            <li :style="downloadtyps==item.id?'color:'+$store.state.themeColor:''"-->
<!--								v-for="(item,index) in downloadtypst" @click="downloadtypsclick(item.id)" :key="index"-->
<!--								>-->
<!--					                {{item.name}}-->
<!--					            </li>-->
<!--					        </ul>-->
<!--					    &lt;!&ndash; </el-scrollbar> &ndash;&gt;-->
<!--					</div>-->
<!--					&lt;!&ndash; <div class="nav-item"  :class="downloadtyps==item.id?'downloadtypsclass':''" v-for="(item,index) in downloadtypst" @click="downloadtypsclick(item.id)" :key="index">-->
<!--						{{item.name}}-->
<!--						-->
<!--					</div> &ndash;&gt;-->
<!--				</div>-->
<!--				&lt;!&ndash; <div class="nav-but">-->
<!--					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phquerytopxia.png" />-->
<!--				</div> &ndash;&gt;-->
<!--			</div>-->
<!--			-->
<!--		</div>-->
<!--		<div class="phquerypdf" v-for="(item,index) in downloadlistst" :key="index">-->
<!--			<div class="phquerypdf-left">-->
<!--				<div>-->
<!--					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phquerypdf.png" />-->
<!--				</div>-->
<!--				<div class="text">{{item.title}}</div>-->
<!--			</div>-->
<!--			<div class="phquerypdf-right">-->
<!--				<div @click="navtoshiyan(item.file)">-->
<!--					{{onlinepreview}}-->
<!--				</div>-->

<!--&lt;!&ndash;				<img @click="dolofle(item)" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phqueryxiazai.png" />&ndash;&gt;-->
<!--			</div>-->
<!--		</div>-->
<!--		<div class="phquerymore">-->
<!--			<div class="phquerymore-but" @click="flesaca()" v-if="morenose">-->
<!--				{{quenetworkco}}-->
<!--				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phqueryfooxia.png" />-->
<!--			</div>-->
<!--		</div>-->
<!--		<div class="commonprobkem" id="4">-->
<!--			<div class="commonprobkem-hea">-->
<!--				{{comprob}}-->
<!--			</div>-->
<!--			<div class="commonprobkem-nav">-->
<!--				<ul>-->
<!--				    <li :style="problemtypestssy==item.id?'color:'+$store.state.themeColor:''"-->
<!--						 v-for="(item,index) in problemtypest" @click="problemtypestssyclick(item.id)" :key="index">-->
<!--				        {{item.name}}-->
<!--				    </li>-->
<!--				</ul>-->
<!--				&lt;!&ndash; <div class="commonprobkem-item" :class="problemtypestssy==item.id?'problemtypestssyclass':''" v-for="(item,index) in problemtypest" @click="problemtypestssyclick(item.id)" :key="index">-->
<!--					{{item.name}}-->
<!--				</div> &ndash;&gt;-->
<!--			</div>-->
<!--			<div class="instructions-foo">-->
<!--				<el-collapse accordion>-->
<!--				  <el-collapse-item v-for="(item,index) in problemlistst" :key="index">-->
<!--				    <template slot="title">-->
<!--				      {{item.title}}-->
<!--				    </template>-->
<!--				    <div>{{item.content}}</div>-->
<!--				  </el-collapse-item>-->
<!--				</el-collapse>-->
<!--			</div>-->
<!--		</div>-->
		<hpfooter ref="footer"></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from '../../storage/storage.js';
	import positionBar from '../../components/ph-position-bar.vue'


	export default{
		data(){
			return{
				id:'',
				pcquersu:'',
				quersu:'',
				morenose:true,
				quenetworkco:'显示更多',
				uservices:'用户服务',
				anticoniden:'防伪鉴别',
				dadownlo:'资料下载',
				maintenance:'维护保养',
				haanticoniden:'防伪查询',
				comprob:'常见问题',
				toptitle:'为了方便广大用户查询,我司于近期升级了防伪查询系统',
				foptitle:'温馨提示：您可以在啄木鸟产品外包装的防伪标签上找到防伪码',
				onlinepreview:'在线预览',
				tips:"请输入防伪码",
				querysub:'提交',
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				downloadtyps:1,
				type_id:2,
				typesss_id:2,
				problemtypestssy:2,
				downloadtypst:'',
				downloadlistst:'',
				downloadlistst_tpm:"",
				problemtypest:'',
				problemlistst:'',
				value: '',
				valuelang: '',
				maintenancetyps:0,
				wehnums:8,
				weihtfa:true,
				categorylist:[],
				list_img: [
				  //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png"),id:1,is_cover:false},
				  //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png"),id:2,is_cover:false},
				  //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png"),id:3,is_cover:false},
				  //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png"),id:4,is_cover:false},
				  //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic5.png"),id:5,is_cover:false},
						// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png"),id:6,is_cover:true},
						// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png"),id:2,is_cover:false},
						// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png"),id:3,is_cover:false},
						// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png"),id:4,is_cover:false},
				],
				positionNav:[
					{
						title:'Home',
						path:'/phhome',
					},
					{
						title:'Users Service',
						path:'',
					},
				]
			}
		},
		created() {
			this.pageParam()
			// this.pcdownloadtpmlist()
			this.getProductList()
			this.pcdownloadtype()
			this.pcdownloadlist()
			this.pcproblemtype()
			this.pcproblemlist()
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				console.log('手机手机21321321')


			}else{
				this.$router.push({path:'./pcquerys',query:{e:'1'}})
				return
			}
			this.ress()

		},
		components:{
			hpfooter,
			hpheader,
			positionBar
		},
		watch:{
			'$route': 'getParams'
		},
		methods:{
			oponzmnqu(){
				/* let af=23682052 */
				let af=this.quersu
				/* window.location.href = 'URL'; */
				window.location.href="http://cx.glwoodpecker.com.cn:88/Wp/gl?af="+af;
			},
			flesaca(){
				this.wehnums+=8
				this.pcdownloadlist()


			},
			dolofle(e){
				var name = e.title;
				    var url = e.file;
				    var suffix = url.substring(url.lastIndexOf("."), url.length);
				      //跳过浏览直接下载
				    fetch(url)
				        .then(res => res.blob())
				        .then(blob => {
				        const a = document.createElement("a");
				        const objectUrl = window.URL.createObjectURL(blob);
				        a.download = name;
				        a.href = objectUrl;
				        a.click();
				        window.revokeObjectURL(objectUrl);
				    })
			},
			navtoshiyan(e){
				window.open(e)
			},
			problemtypestssyclick(e){
				this.problemtypestssy=e
				this.typesss_id=e
				this.pcproblemlist()
			},
			pcproblemlist(){
				let data={
						type_id:this.typesss_id,
						mold:'h5',
						lang:session.get("lang") == null ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
						page:1,
						pageSize:100000000,

					}
				this.$api.get_channel_problem_list(data).then((res) => {
						console.log('4444',res.data)
						this.problemlistst=res.data

				});
			},
			pcproblemtype(){
				let data={
						type_id:this.type_id,
						lang:session.get("lang") == null ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
						page:1,
						pageSize:10000000,

					}
				this.$api.get_channel_problem_type(data).then((res) => {
						console.log('3333',res.data)
						this.problemtypest=res.data
						this.problemtypestssy = res.data[0].id
						this.problemtypestssyclick(this.problemtypestssy)
				});
			},
			pcdownloadlist(){
				let data={
				type_id:this.type_id,
				mold:'h5',
				lang:session.get("lang") == null ? 'cn' : session.get("lang"),
				channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
				page:-1,
				pageSize:this.wehnums,

				}
				this.$api.get_download_list(data).then((res) => {
				this.downloadlistst=res.data.data
				if(this.wehnums>this.downloadlistst.length){
					this.morenose=false
				}
				});
			},
			downloadtypsclick(e){
				this.downloadtyps=e
				this.type_id=e
				this.pcdownloadlist()

			},
			pcdownloadtype(){
				let data={
						lang:session.get("lang") == null ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
						page:1,
						pageSize:1000,
					}
					console.log('this.datathis.datathis.data',data)
				this.$api.get_channel_download_type(data).then((res) => {
						console.log('1111',res.data)
						this.downloadtypst=res.data
						this.downloadtypsclick(this.downloadtypst[0].id)
				});
			},
			getProductList(){
				let data={
					lang:session.get('lang'),
					channel_id: session.get('channel_id'),
				}
				this.$api.get_channel_category_list(data).then((res) => {
					// pcdownloadtpmlist
					console.log('categorylistcategorylistcategorylist',res)
					this.categorylist=res.data
					if(res.data.length>0){
						this.pcdownloadtpmlist(res.data[0].id)
					}
					this.$refs.footer.scrollIntoView(this.$route.query.select)
				});
			},
			pcdownloadtpmlist(e){
				this.maintenancetyps = e
				// mold:'pc',
				// 	lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
				// 	channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				// 	page:1,
				// 	pageSize:this.wehnums,
				// 	category_id:this.maintenancetyps
				let data={
						mold:'h5',
						lang:session.get("lang") == null ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
						page:1,
						pageSize:5000000,
						category_id:this.maintenancetyps
					}
					console.log('看这里')
				this.$api.get_channel_tpm(data).then((res) => {
						this.downloadlistst_tpm=res.data
						this.weihcons=this.downloadlistst_tpm.length
						console.log('this.weihconsthis.weihconsthis.weihcons',res.data)
						if(this.wehnums>this.weihcons&&this.wehnums!==this.weihcons){
							this.weihtfa=false
						}
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.uservices = "用户服务"
					this.quenetworkco="显示更多"
					this.anticoniden='防伪鉴别',
					this.haanticoniden='防伪查询',
					this.dadownlo='资料下载',
					this.maintenance='维护保养',
					this.comprob='常见问题',
					this.toptitle='为了方便广大用户查询,我司于近期升级了防伪查询系统'
					this.foptitle='温馨提示：您可以在啄木鸟产品外包装的防伪标签上找到防伪码'
					this.onlinepreview='在线预览'
					this.tips="请输入防伪码"
					this.querysub="提交"
				}else{
					this.uservices = "USERS SERVICE"
					this.quenetworkco="Show more"
					this.anticoniden='Anti-Fake Inquiry',
					this.haanticoniden='Anti-Fake Inquiry',
					this.dadownlo='Download',
					this.maintenance='Maintenance',
					this.comprob='FAQ',
					// this.toptitle='In order to facilitate users query, our company has recently upgraded the anti-counterfeiting query system'
					this.toptitle='To verify product authenticity, please send the serial number directly to our official email:'
					// this.foptitle='Warm tip: you can find the anti-counterfeiting code on the anti-counterfeiting label of the outer package of woodpecker products'
					this.foptitle='woodpecker4@glwoodpecker.com'
					this.onlinepreview='Preview'
					this.tips="Please input anti-fake code"
					this.querysub="submit"
				}
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			getParams(){
				var selectId = this.$route.query.select;
				this.$refs.footer.scrollIntoView(selectId)
			}
		},
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phquery{
		background: #FFF;
		padding-top: 0.88rem;
	}

	.phqueryheader{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-bottom: 0.4rem;
	}
	.phquerycont{
		/*display: flex;
		flex-direction: column;
		align-items: center;
		width: 7.5rem;
		height: 3.8rem;
		background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phquerybanner.png) 100% 100%;
		background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250721/b1768185b2a4ec4bd94b638437e64cd3.jpg) 100% 100% no-repeat;
		background-size: contain;*/
    position: relative;

	}
  .phquerycont-banner img{
    width: 100%;
    display: block;
  }
  .phquerycont-txt {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
	.phquerycont-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 0.02rem;
		padding: .8rem 0 .6rem 0;
    text-align: center;
	}
	.phquerycont-title{
		font-size: 0.24rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
    padding: 0 .1rem;
		text-align: center;
    line-height: 1.8;
	}
  .phquerycont-ftitle {
    font-size: 0.36rem;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 0.01rem;
    margin-top: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 .1rem;
    text-align: center;
    line-height: 1.4;
  }
	.phquerycont-inputcont{
		background-color: #CCCCCC;
		width: 7rem;
		height: 0.6rem;
		margin-top: 0.4rem;
		margin-bottom: 0.16rem;
		border-radius: 0.3rem;
		padding: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.phquerycont-input{
		display: flex;
		align-items: center;
		width: 7rem;
		height: 0.6rem;
		background: #FFFFFF;
		border-radius: 0.3rem;
		border: 0.01rem solid #CCCCCC;
	}
	.phquerycont-input input{
		margin-left: 0.3rem;
		width: 5rem;
		height: 0.4rem;
		border: none;
		outline: none;
		display: flex;
	}
	.phquery-inputbut{
		width: 1.1rem;
		height: 0.46rem;
		background: #E31E24;
		border-radius: 0.23rem;
		font-size: 0.16rem;
		font-weight: 400;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 0.30rem;
	}
	.phquerydown{

	}
	.phquerydown-hea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 0.8rem;
		padding-bottom: 0.4rem;
	}
	.phquerydown-nav{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.nav-cont{
		width: 6.5rem;
		display: flex;
		flex-wrap: nowrap;
		overflow: auto;
		margin-left: 0.25rem;
	}
	.nav-item{
		min-width: 2.7rem;
		text-align: center;
		width: 100%;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
	.navfiest{
		margin-right: 0.32rem;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		min-width: 0.8rem !important;
	}
	.nav-but{
		width: 0.28rem;
		height: 0.28rem;
		margin-right: 0.35rem;
		display: flex;
	}
	.nav-but img{
		width: 100%;
		height: 100%;
	}
	.phquerypdf{
		width: 7.5rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.phquerypdf-left{
		display: flex;
		align-items: center;
		font-size: .2rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.04rem;
	}
	.phquerypdf-left .text {
		width: 5.5rem;
	}
	.phquerypdf-left img{
		width: 0.36rem;
		height: 0.36rem;
		margin-left: 0.3rem;
		margin-right: 0.12rem;
	}
	.phquerypdf-right{
		display: flex;
		align-items: center;
		font-size: 0.2rem;
		font-weight: 400;
		color: #999999;
		letter-spacing: 0.03rem;
		padding-right: .15rem;
	}
	.phquerypdf-right img{
		width: 0.28rem;
		height: 0.28rem;
		margin-left: 0.12rem;
		margin-right: 0.3rem;
	}
	.phquerymore{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.3rem;
		margin-bottom: 0.6rem;
	}
	.phquerymore-but{
		width: 1.76rem;
		height: 0.6rem;
		border-radius: 0.04rem;
		border: 0.01rem solid #CCCCCC;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}
	.phquerymore-but img{
		width: 0.24rem;
		height: 0.24rem;
		margin-left: 0.08rem;
	}
	.commonprobkem{
		background: #FAFAFA;
		padding-top: 0.78rem;
		padding-bottom: 0.65rem;
		color: #5d5f5f;
	}
	.commonprobkem-hea{
		font-size: 0.36rem;
		font-weight: 600;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.4rem;
	}
	.commonprobkem-nav{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 0.4rem;
		overflow: auto;
		width: 100%;
	}
	.commonprobkem-item{
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.20rem;
		margin-right: 0.32rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		overflow: auto;
		width: 4rem;
	}
	.commonprobkem-cont{
		width: 6.9rem;
		height: 1.22rem;
		background: #FFFFFF;
		margin-left: 0.25rem;
		padding-top: 0.24rem;
		padding-left: 0.24rem;
		margin-bottom: 0.24rem;
	}
	.commonprobkemcont-name{

		font-size: 0.24rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		align-items: center;
	}
	.commonprobkemcont-name img{
		width: 0.32rem;
		height: 0.32rem;
	}
	.commonprobkemcont-title{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
		margin-top: 0.14rem;
	}
	.phmaintainhea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 0.8rem;
		padding-bottom: 0.4rem;
	}
	.phmaintain-cont{
		display: flex;
		flex-wrap: wrap;
	}
	.pamaintain-item{
		width: 3.5rem;
	}
	.maintainite-hea{
		width: 3.5rem;
		height: 3.5rem;
	}
	.maintainite-hea img{
		width: 3.5rem;
		height: 3.5rem;
		border-radius: 0.06rem;
	}
	.maintainte-foo{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.16rem;

	}
	.maintainte-foo img{
		width: 0.28rem;
		height: 0.28rem;
		margin-left: 0.12rem;
		margin-right: 0.3rem;
	}
	.mainite-left{

	}
	.instructions-foo{
		padding-bottom: 0.5rem;
		padding: 0.2rem 0.3rem;
	}
	.el-collapse-item__header{
		height: 100%;
		line-height: 0.4rem;
		padding: 0.2rem 0.3rem;
	}
	.el-collapse-item__content{
		padding: 0.2rem 0.3rem;
	}
	.problemtypestssyclass{
		color: #D03E3D;
	}
	.img-list{
		display: flex;
		font-size: 0.28rem;
		color: #5d5f5f;
	}
	.img-list ul{
		display: flex;
	}
	.img-list ul li{
		list-style: none;
		flex-shrink: 0;
		margin-right: 0.3rem;
	}
	.img-list ul li:first-child{
		margin-left: -0.55rem;
	}
	.downloadtypsclass{
		color: #D03E3D;
	}
	.commonprobkem-nav{
		display: flex;
		font-size: 0.28rem;
	}
	.commonprobkem-nav ul{
		display: flex;
	}
	.commonprobkem-nav ul li{
		list-style: none;
		flex-shrink: 0;
		margin-right: 0.3rem;
	}
	.commonprobkem-nav ul li:first-child{
		margin-left: -0.55rem;
	}
	.maintenance_video{
		/* background: red; */
		width: 90%;
		margin: 0 0 0 5%;
		display: flex;
		flex-wrap: wrap;
	}
	.pcmaintenance-item{
		width:3rem ;
		    margin: 0 0 0 2.5%;
	}
	.phquery .shop-video{
		position: relative;
		width: 3rem;
		height: calc(27rem / 16) ;
		display: flex;
	}
	.shopicon-left{
		font-size: calc(12rem / 50);
	}
	.padding-top-3 {
		padding-top: .3rem;
	}
</style>
